import { RouteFactory } from "@app/routePaths";

/**
 * Component to render in assessment tab at How to Nominate page DTA
 */
const AssessmentSection = (): React.ReactElement => {
  return (
    <div
      className="mb-5 pb-5 font-public-sans"
      data-testid="assessment-section-component"
    >
      <ul className="list-outside list-decimal pb-1 pl-8 leading-[1.4]">
        <li className="mb-3">
          <p className="mb-0">Design Thinking Process & Strategies</p>

          <p>
            Showcase a proficient use of design thinking methodologies,
            providing strategic insights that effectively address complex and
            interdisciplinary challenges.
          </p>
        </li>

        <li className="mb-3">
          <p className="mb-0">Originality, Functionality & Aesthetics</p>

          <p>
            Highlight how the design introduces significant innovation, pushing
            the boundaries beyond existing solutions and setting a new benchmark
            in the field. Demonstrate a harmonious balance between the visual
            appeal and practical functionality of the design.
          </p>
        </li>

        <li className="mb-3">
          <p className="mb-0">Utilisation of AI & Advanced Technologies</p>

          <p>
            Illustrate the strategic and sustainable integration of AI and
            emerging technologies to tackle complex, interdisciplinary problems.
          </p>
        </li>

        <li className="mb-3">
          <p className="mb-0">Ethical Consideration & Sustainability</p>

          <p>
            Exhibit a commitment to ethical design principles, including respect
            for human rights, as well as a focus on environmental
            sustainability.
          </p>
        </li>

        <li className="mb-3">
          <p className="mb-0">Impact</p>

          <p>
            Present evidence of the design’s impact, both quantitatively and
            qualitatively.
          </p>
        </li>
      </ul>

      <ul className="list-outside list-disc pb-4 pl-8 leading-[1.4]">
        <li>
          Quantitative Impact: Contribution to economic growth, setting
          groundbreaking design standards, enhancing business and community
          wealth, etc.
        </li>

        <li>
          Qualitative Impact: Improving sustainable quality of life, providing
          an exceptional user experience, and establishing the design as an
          iconic, internationally recognised standard, etc.
        </li>
      </ul>

      <p className="mb-8">
        <a
          href={RouteFactory.dtaAwardsPage}
          className="font-bold text-blue-175 hover:text-gray-850 hover:underline"
        >
          Click here
        </a>
        &nbsp;for the eligibility
      </p>
    </div>
  );
};

export default AssessmentSection;
